import './BackLink.scss';

import React from 'react';
import PropTypes from 'prop-types';

import Button from 'components/Button';
import Icon from 'components/Icon';

export default class BackLink extends React.Component {
    static propTypes = {
        className: PropTypes.string
    };

    render() {
        return (
            <Button className={`c-back-link ${this.props.className || ''}`}
                    onClick={() => window.history.back()}
                    noStyles>
                <Icon type="chevron-left" /> Back
            </Button>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/BackLink/index.js